import React, { useEffect, useState } from "react";
import Image from "../Image/Image";
import classes from "./PrimaryButtonLoader.module.scss";

const PrimaryButtonLoader = (props) => {

  const [isActive, setIsActive] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoad, setIsLoad] = useState(true);
  const { appState } = props;
  useEffect(() => {
    setTimeout(() => {
      setIsLoad(false);
    }, 1800);
  });
  useEffect(() => {
    if (appState.loading) {
      setIsActive(true);
      setTimeout(() => {
        !appState.isSubmitedSuccess && setIsLoader(true);
        //setIsLoader(true);
      }, 125);
    }
    if (appState.isSubmitedSuccess) {
      setIsActive(false);
      setIsLoader(false);
      setIsSuccess(true);
    }
    if (!appState.loading && !appState.isSubmitedSuccess) {
      setIsActive(false);
      setIsLoader(false);
      setIsSuccess(false);
    }
  }, [appState]);

  // Clean the isActive state in the unmount
  useEffect(() => {
    return () => {
      setIsActive(false);
    };
  }, []);
  return (
    <div className={classes.ButtonCont}>
      <button
        id="primaryButtonLoaderId"
        className={`
                ${isLoad ? classes.onLoad : ""} 
                ${isActive && isLoader ? classes.active + " " + classes.loader : ""} 
                ${isSuccess ? classes.success : ""} 
                ${props.className} ${props.disabled && classes.DisableBtn}
            `}
        onClick={(e) => props.handleClick(e)}
        disabled={(isLoader && isActive) || isSuccess  || props.disabled}
        data-testid={props.dataTestid}
      >
        {!isActive && !isSuccess && (
          <span className={classes.Content}>{props.label}</span>
        )}
        {props.filename && !isActive && !isSuccess && (
          <Image
            className={classes.Image}
            filename={props.filename ? props.filename : "Path426"}
            renditions={props.renditions}
            ext={props.ext ? props.ext : "png"}
          />
        )}

        {!props.filename && !isActive && !isSuccess && (
          <Image
            className={classes.Image}
            filename={
              props.disabled ? "arrow_forward_black-2" : "arrow_forward_black-1"
            }
            renditions={["2x"]}
            ext={"png"}
          />
        )}

        {isSuccess && (
          <Image
            className={`${classes.ImageFinish} img-finish`}
            filename="Path -21"
            renditions={props.renditions}
            ext="png"
          />
        )}
      </button>
    </div>
  );
};

export default PrimaryButtonLoader;
